// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hi","advertCardFooter__row":"c-a_hj","advertCardFooter__name":"c-a_hk","advertCardFooter__price":"c-a_hl","advertCardFooter__age":"c-a_hm"};